<template>
  <div class="layout-error">
    <img class="layout-error__image" src="../../../../public/img/error.png" alt="lock">
    <div class="layout-error__message">{{errorMessage}}</div>
  </div>
</template>

<script>
export default {
  name: 'LayoutError',
  props: {
    error: {
      type: Error,
      required: true
    }
  },
  computed: {
    errorMessage () {
      return (this.error && this.error.message) || this.L10n('editor-error')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .layout-error{
    height 100%
    width 100%
    display flex
    flex-direction column
    justify-content center
    align-items center
    &__message{
      color: rgb(226, 106, 106)
    }
  }
</style>
